// extracted by mini-css-extract-plugin
export var displayNone = "_of-6";
export var imgContainer = "_of-2";
export var overflowHidden = "_of-3";
export var productInfoCardButtonContainer = "_of-5";
export var productTitleText = "_of-4";
export var rightArrow = "_of-1";
export var rightArrowContainer = "_of-0";